import type {
	ICellValue,
	ICurrencyField,
	ICurrencyFieldProperty,
	InternalState,
} from '../types'

import z from 'zod'

import { getFieldDefaultProperty } from '../constants'
import { str2number } from '../convert'
import { numberToShow } from '../number'
import { str2Currency } from '../string'
import { FieldType } from '../types'
import { NumberBaseField } from './number-base-field'

export class CurrencyField extends NumberBaseField {
	constructor(
		public override field: ICurrencyField,
		public override state: InternalState
	) {
		super(field, state)
	}

	static readonly propertySchema = z.object({
		symbol: z.string(),
		precision: z.number().int().min(0).max(10),
		defaultValue: z.string(),
	})

	// the data of preview, includes (positive or negative sign) + currency symbol + scientific notation number or normal number + thousand separator
	override cellValueToString(cellValue: ICellValue): string | null {
		if (this.validate(cellValue)) {
			const { symbol, precision } = this.field.property
			let cellString: string | null

			cellString = numberToShow(cellValue, precision)
			cellString = str2Currency(cellString, symbol, 3, ',')

			return cellString || null
		}

		return null
	}

	// return new records' default value of field attributes
	override defaultValue(): ICellValue {
		const { defaultValue } = this.field.property

		return defaultValue ? str2number(defaultValue) : null
	}

	validateProperty() {
		return CurrencyField.propertySchema.safeParse(this.field.property)
	}
	static defaultProperty() {
		return getFieldDefaultProperty(FieldType.Currency) as ICurrencyFieldProperty
	}
}
